class Cart extends HTMLElement {
	constructor() {
		super();

		this.lineItems = this.querySelectorAll("[name='updates[]']");
		this.form = this.querySelector(".cart");
		this.empty = this.querySelector(".empty-state");
	}

	displayEmpty() {
		// alert("empty")

		if (this.form) this.form.classList.add("hidden");
		this.empty.classList.remove("hidden");
		// TODO: needed?
		// window.location?.reload();
	}

	updateCartItems() {
		// TODO: Re-enable before going live with this
		fetch(`${window.Shopify.routes.root}cart`, {
			method: "GET",
		})
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);

				// Update section HTML with results
				document.querySelector(
					"#main-cart-items"
				).outerHTML = html.querySelector(
					"#main-cart-items"
				).outerHTML;

				// HACK: The images in the updated cart items are not showing, forcing them to show
				setTimeout(() => window.Zero.lazyLoad.update(), 1);
			});
	}
}

export default Cart;
